import get from 'lodash/get'
import { storage } from '@/utils'

export default {
	namespaced : true,
	state      : {
		guides       : [],
		courses      : [],
		totalGuides  : 0,
		totalCourses : 0,
	},
	getters : {},
	actions : {
		fetchGuides ({ dispatch }) {
			return dispatch('fetch', {
				type    : 'guides',
				url     : this._vm.$urls.marketing('wp-json/wp/v2/omu-guides?per_page=8&orderby=menu_order&order=desc&_embed=1'),
				imgSize : 'medium_large',
			})
		},
		fetchCourses ({ commit, dispatch }) {
			return dispatch('fetch', {
				type : 'courses',
				url  : this._vm.$urls.marketing('wp-json/ldlms/v1/courses?per_page=8&orderby=menu_order&order=desc&_embed=1'),
			})
		},
		fetch ({ commit, dispatch }, { type, url, imgSize = 'medium' }) {
			return new Promise((resolve, reject) => {
				commit('fetching', type, { root: true })

				const update = ({ items, total }) => {
					commit('fetched', type, { root: true })
					commit('doneLoading', type, { root: true })
					commit(`${type}Set`, items)
					commit(`${type}SetTotal`, total)
					resolve()
				}

				const found = storage.session.getItem(`omu-${type}`)
				if (get(found, 'items')) {
					return update(found)
				}

				return this._vm.$api.get({ url })
					.then(({ body, headers }) => {
						const found = {
							items : body.map(item => ({
								id    : item.id,
								title : get(item, 'title.rendered'),
								link  : item.link,
								img   : get(item, `_embedded.wp:featuredmedia.0.media_details.sizes.${imgSize}`),
							})),
							total : headers['x-wp-total'],
						}
						storage.session.setItem(`omu-${type}`, found)
						update(found)
					})
					// eslint-disable-next-line handle-callback-err
					.catch(({ ...error }) => {
						commit('doneFetching', type, { root: true })
						dispatch('handleError', {
							explanation : `Something went wrong while fetching ${type}.`,
							error,
							reject,
						})
					})
			})
		},
		handleError ({ commit }, { explanation, error, reject }) {
			if (explanation) {
				error.explanation = explanation
			}

			error.closes = true
			commit('addError', error, { root: true })
			console.error({ error })
			reject(error)
		},
	},
	mutations : {
		guidesSet (state, payload) {
			state.guides = payload
		},
		coursesSet (state, payload) {
			state.courses = payload
		},
		guidesSetTotal (state, payload) {
			state.totalGuides = payload
		},
		coursesSetTotal (state, payload) {
			state.totalCourses = payload
		},
	},
}
